import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Tooltip Component Test card's body on the Test UI Components page: short, long and multi-line tooltips.
@Component({
  selector: 'cs-test-tooltip-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item>
        <cs-label>Hover over the info icons to see tooltips:</cs-label>
      </cs-item>
      <cs-item>
        <cs-label>Simple tooltip:</cs-label>
        <cs-tooltip item-right [text]="'This is a simple tooltip with the new popup menu styling' | untranslated"></cs-tooltip>
      </cs-item>
      <cs-item>
        <cs-label>Long tooltip:</cs-label>
        <cs-tooltip item-right
        [text]="'This is a longer tooltip that demonstrates how the text wraps when it exceeds the maximum width. The tooltip uses the same dark background and styling as the popup menu.' | untranslated"></cs-tooltip>
      </cs-item>
      <cs-item>
        <cs-label>Multi-line tooltip:</cs-label>
        <cs-tooltip item-right
        [text]="'Line 1: First piece of information\\nLine 2: Second piece of information\\nLine 3: Third piece of information' | untranslated"></cs-tooltip>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestTooltipCardComponent {}
